import axios from "axios";

const API_BASE_URL =
  "https://gkz1ukftsi.execute-api.us-west-1.amazonaws.com/prod";

export interface RecipeSummary {
  recipe_id: string;
  title: string;
  cooking_time?: string;
  servings?: string;
  description?: string;
  category?: string;
}

export interface RecipeDetail extends RecipeSummary {
  ingredients?: string;
  instructions?: string;
  raw_markdown?: string;
}

export default class RecipeApiClient {
  async fetchRecipes(category?: string): Promise<RecipeSummary[]> {
    const url = category
      ? `${API_BASE_URL}/recipes?category=${encodeURIComponent(category)}`
      : `${API_BASE_URL}/recipes`;
    const response = await axios.get(url);
    return response.data;
  }

  async fetchRecipeById(recipeId: string): Promise<RecipeDetail> {
    const response = await axios.get(`${API_BASE_URL}/recipes/${recipeId}`);
    return response.data;
  }

  async createRecipe(textDescription: string): Promise<RecipeDetail> {
    const response = await axios.post(`${API_BASE_URL}/recipes`, {
      text: textDescription,
    });
    return response.data;
  }
}
